import actionCreatorFactory from 'typescript-fsa'

import { GetInstagramPageFeedRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'
import { GetInstagramFeedResponse } from '@3m5/sm_publish-frontend-api/models'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const getIgPageFeedInitiated = actionCreator<GetInstagramPageFeedRequest>('GET_IG_PAGE_FEED_INITIATED')
export const getIgPageFeed = actionCreator.async<GetInstagramPageFeedRequest, GetInstagramFeedResponse>('GET_IG_PAGE_FEED')
